import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import compareVersions, {
    VERSION_CM_11214_DASHBOARD_ADVANCEMENT,
    VERSION_CM_5058_DASHBOARD,
} from "../../cores/version";
import { Button, Grid } from "@mzc-pdc/ui";
import theme from "@styles/theme";
/* components */
import { default as AsIsDashboard } from "../../components/dashboard";
import { default as ToBeDashboard } from "../../components_v2/dashboard";

class Dashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            contentIndex: 0,
            projectIndex: 0,
        };
    }
    render() {
        const { stage } = this.props;

        return (
            <React.Fragment>
                {(compareVersions(VERSION_CM_5058_DASHBOARD, stage.version) <= 0 &&
                    (compareVersions(VERSION_CM_11214_DASHBOARD_ADVANCEMENT, stage.version) <= 0 ? (
                        <ToBeDashboard />
                    ) : (
                        <AsIsDashboard />
                    ))) || (
                    <div className={"content-wrapper dashboard"}>
                        <div className={"dashboard-head"}>
                            <img src="/images/dashboard/temp/top.png" alt="" />
                        </div>
                        <div className="dashboard-body">
                            <div className={"item item-1"}>
                                <img src="/images/dashboard/temp/item-1.png" alt="" />
                            </div>
                            <div className={"item item-2"}>
                                <img src="/images/dashboard/temp/item-2.png" alt="" />
                            </div>
                            <div className={"item item-3"}>
                                <img src="/images/dashboard/temp/item-3.png" alt="" />
                            </div>
                            <div className={"item item-4"}>
                                <img src="/images/dashboard/temp/item-4.png" alt="" />
                            </div>
                            <div className={"item item-5"}>
                                <img src="/images/dashboard/temp/item-5.png" alt="" />
                            </div>
                            <div className={"item item-6"}>
                                <img src="/images/dashboard/temp/item-6.png" alt="" />
                            </div>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

let mapStateToProps = (state) => {
    return {
        stage: state.stage,
    };
};

Dashboard = connect(mapStateToProps)(Dashboard);
export default withTranslation()(Dashboard);
